<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="login_formulaire">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-6 col-xs-12">
                <form [formGroup]="loginform">
                    <div class="login_cust_input_box">
                        <input type="text" name='nom' formControlName="username" placeholder="Nom d'utilisateur">
                        <span class="img-form" placement="top" triggers="mouseenter:mouseleave">
                    <img src="assets/images/nom.svg" alt="">
                    <span  class="text-red-plus">*</span>
                        </span>
                    </div>
                    <!-- <div class="cust_input_box">
                        <input type="password" name='nom' formControlName="password" placeholder="Mot de passe">
                        <span class="img-form" placement="top" triggers="mouseenter:mouseleave">
                    <img src="assets/images/nom.svg" alt="">
                    <span  class="text-red-plus">*</span>
                        </span>
                    </div> -->

                    <div class="login_cust_input_box">
                        <input [type]="showPassword ? 'text' : 'password'" name='nom' formControlName="password" placeholder="Mot de passe">
                        <span class="img-form" placement="top" triggers="mouseenter:mouseleave">
                          <img src="assets/images/nom.svg" alt="">
                          <span class="text-red-plus">*</span>
                        </span>
                        <span class="toggle-password" (click)="togglePasswordVisibility()">
                          <img 
                            *ngIf="showPassword" 
                            src="assets/images/hide.png" 
                            alt="Hide Password">
                          <img 
                            *ngIf="!showPassword" 
                            src="assets/images/show.png" 
                            alt="Show Password">
                        </span>
                    </div>

                </form>

                <div class="text-danger text-center mt-1" *ngIf="userInconnu!=''"> {{userInconnu}}
                </div>

                <div class="custom_connexion">
                    <button type="button" class="btn btn-primary" (click)="connecter()">
                        Se connecter
                        <i class="fal fa-spinner fa-pulse" *ngIf="loaderVisible"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <p>Vous n'avez pas de compte ?</p>
    <button type="button" class="btn btn-secondary" (click)="openRegisterModal()">Créez-en un !</button>
</div>